import React from "react";
import { Link } from "react-router-dom";
import newsData from "../data/newsData";

const LatestNews = () => {
  return (
    <section className="relative z-[12] bg-brandBlue text-white font-outfit px-6 py-16 xs:py-8 xxs:py-8 min-h-screen overflow-hidden">
      {/* Gradient overlays */}
      <div className="absolute top-[-100px] left-[-100px] w-[300px] h-[300px] bg-softGreen/30 blur-3xl rounded-full z-0" />
      <div className="absolute bottom-[-100px] right-[-100px] w-[300px] h-[300px] bg-brandGreen/20 blur-3xl rounded-full z-0" />

      <div className="relative z-10 max-w-4xl mx-auto">
        {/* <h2 className="text-4xl xs:text-2xl xxs:text-2xl font-bold mb-12 xs:mb-6 xxs:mb-6 text-center tracking-tight">
          Latest News
        </h2> */}
        <h3 className=" text-2xl leading-[1.3125rem] mb-[3rem] uppercase tracking-[0.2em] font-normal text-center text-white xxs:text-lg xs:text-lg xxs:mb-[1.5rem] xs:mb-[1.5rem]">
          Latest News
        </h3>

        <div className="space-y-8">
          {newsData.map((item) => (
            <div
              key={item.id}
              className="bg-gradient-to-r from-[#0F1C4D] to-[#101B3D] border border-[#1B2A5B] rounded-2xl p-6 shadow-md hover:shadow-lg transition-shadow"
            >
              <div className="mb-3  flex items-center justify-between">
                <h3 className=" text-[1.3125rem] xs:text-base xxs:text-base font-semibold">
                  {item.title}
                </h3>
                <span className="text-sm text-[#04DDAD]">{item.date}</span>
              </div>
              <p className="text-gray-300  text-base mb-4 line-clamp-5">
                {item.summary}
              </p>
              <Link
                to={`/latestnews/${item.id}`}
                className="text-sm font-semibold text-[#04DDAD] hover:underline"
              >
                Read more →
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LatestNews;
